import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { euro } from "@/lib/format";
import { HardHat, ArrowRight } from "lucide-react";
import { StatoBadge } from "@/components/prestazioni/StatoMese";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export function PrestazioniCard() {
  const nav = useNavigate();
  const { data } = useQuery({ queryKey: ["prest-dashboard"], queryFn: async () => (await api.get("/prestazioni/dashboard")).data });
  if (!data || data.n_schede === 0) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5" data-testid="dash-prestazioni">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-400 flex items-center gap-1.5"><HardHat className="h-3.5 w-3.5 text-primary" /> Prestazioni di manodopera · {MESI[data.mese - 1]} {data.anno}</div>
          <div className="font-mono text-2xl font-bold text-slate-900 mt-1" data-testid="dash-prest-fatturabile">{euro(data.fatturabile_mese)}</div>
          <div className="text-xs text-slate-500">fatturabile del mese · {data.giornate_mese} giornate</div>
        </div>
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm">
          <div className="text-xs text-amber-700">Ancora da fatturare (tutti i mesi)</div>
          <b className="font-mono text-amber-800" data-testid="dash-prest-da-fatturare">{euro(data.da_fatturare_totale)}</b>
        </div>
        <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm">
          <div className="text-xs text-slate-500">Prestazioni attive</div>
          <b className="font-mono text-slate-800" data-testid="dash-prest-attive">{data.attive}</b>
        </div>
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm min-w-[160px]" data-testid="dash-prest-operai-oggi">
          <div className="text-xs text-emerald-700">Operai impegnati oggi</div>
          <b className="font-mono text-emerald-800">{data.n_operai_oggi}</b>
          {Object.entries(data.operai_oggi || {}).map(([cl, dips]) => <div key={cl} className="text-xs text-emerald-800/80 truncate" title={dips.join(", ")}>{cl}: {dips.join(", ")}</div>)}
        </div>
      </div>
      {data.per_cliente.length > 0 && (
        <div className="mt-3 divide-y divide-slate-100 border-t border-slate-100">
          {data.per_cliente.map((c) => (
            <button key={c.commessa_id} onClick={() => nav(`/prestazioni/${c.commessa_id}`)} className="w-full py-2 flex items-center gap-3 text-sm hover:bg-slate-50 rounded px-1 -mx-1" data-testid={`dash-prest-cliente-${c.commessa_id}`}>
              <span className="font-mono text-xs text-slate-400">{c.codice}</span><span className="font-medium text-slate-800 flex-1 truncate text-left">{c.cliente}</span><span className="text-xs text-slate-400">{c.giornate} gg</span>
              <span className="font-mono">{euro(c.fatturabile)}</span><StatoBadge stato={c.stato} />
            </button>
          ))}
        </div>
      )}
      <button onClick={() => nav("/prestazioni")} className="mt-3 text-xs text-primary font-medium inline-flex items-center gap-1 hover:underline" data-testid="dash-prest-link">Vai alle prestazioni <ArrowRight className="h-3 w-3" /></button>
    </div>
  );
}
